module.exports = __webpack_public_path__ + "48e60fd55cea787a185a1b7c96cb8fe4.pdf";